import { create } from "zustand";
import { Membership } from "../api-objects/Membership";
import { CreateProductChannel } from "../enums/CreateProductChannel";

interface ProductsState {
    membership: Membership | null;
    dnaTest: CreateProductChannel | null;
    metabolicHook: boolean | null;
}

interface ProductsStore {
    productsData: ProductsState;
    updateProductsData: (updates: Partial<ProductsState>) => void;
    clearProducts: () => void;
}

// Zustand store
export const useProductsStore = create<ProductsStore>((set) => ({
    // Initialize from localStorage
    productsData: JSON.parse(localStorage.getItem("productsData") || "{}") as ProductsState || {
        membership: null,
        dnaTest: null,
        metabolicHook: null,
    },

    updateProductsData: (updates) => {
        set((state) => {
            const updatedProductsData = { ...state.productsData, ...updates };
            localStorage.setItem("productsData", JSON.stringify(updatedProductsData));
            return { productsData: updatedProductsData };
        });
    },

    clearProducts: () => {
        const clearedProductsData: ProductsState = {
            membership: null,
            dnaTest: null,
            metabolicHook: null,
        };
        set({ productsData: clearedProductsData });
        localStorage.removeItem("productsData");
    },
}));